import React, { useEffect, useState } from "react";
import { IResourceComponentsProps, useGetIdentity, useList, useMany } from "@pankod/refine-core";
import { Form, FormProps, Input, Modal, ModalProps, Select, SelectProps } from "@pankod/refine-antd";
import { useUserContext } from "context/user";
import { ICondition } from "interfaces";
import { DatePicker } from 'antd';
import moment from "moment";
import type {  RangePickerProps } from 'antd/es/date-picker';
// import dayjs from "dayjs";
// import customParseFormat from 'dayjs/plugin/customParseFormat';
// import moment from "moment";
// dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;
type CreateRuleProps = {
    modalProps: ModalProps
    formProps: FormProps
  }
export const EditRetireRule: React.FC<CreateRuleProps> = ({modalProps,formProps}) => {
  const dateFormat = 'YYYY/MM/DD';
   console.log(formProps?.initialValues)
    const { data: user } = useGetIdentity()
    const { userRole } = useUserContext()
    const [showCount,setShowCount]=useState(false)
    const [newRange,setNewRange]=useState<string[]>([])
    const [showdateRange,setShowDateRange]=useState(false)
    const onFinish = async (values: any) => {
      delete values?.date_range_new;
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          updated_by: user?.id,
          date_range:newRange
  
        })
      )
    }
    const { data, isLoading, isError } = useList<ICondition>({
        resource: "rule_conditions",
        metaData:{
            fields:['id','name','key','rule_id']
        }
    
    });

    const conditions = data?.data ?? [];
    console.log({conditions})
    const options: SelectProps['options'] = [];

    for (let i = 1; i <= 50; i++) {
      options.push({
        value: i.toString(),
        label: i.toString(),
      });
    }
    useEffect(() => {
      console.log("data",formProps?.initialValues)
      if(formProps?.initialValues?.condition_attribute==='discrimantion_index_count' || formProps?.initialValues?.condition_attribute==='paper_count' || formProps?.initialValues?.condition_attribute==='discrimantion_index'){
        setShowDateRange(false)
          setShowCount(true)
      }
      else if(formProps?.initialValues?.condition_attribute==="creation_date"){
        setShowCount(false)
        setShowDateRange(true)
      }
      else{
        setShowDateRange(false)
          setShowCount(false)
      }
     
    }, [formProps?.initialValues])
    const toggleShowCount=(value:any)=>{
        console.log("values",value)
        if(value==='discrimantion_index_count' || value==='paper_count' || value==='discrimantion_index'){
          setShowDateRange(false)
            setShowCount(true)
        }
        else if(value==="creation_date"){
          setShowCount(false)
          setShowDateRange(true)
        }
        else{
          setShowDateRange(false)
            setShowCount(false)
        }

    }
    const onChange = (
      value:  RangePickerProps['value'],
      dateString: string[] ,
    ) => {
      setNewRange(dateString)
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };console.log({newRange})
    return(
        <Modal {...modalProps} title="Edit Rule">
        <Form {...formProps} size="large" layout="vertical" onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            // if (response) {
            //   createUserHistory('sections', 'create', response?.data?.id, user?.id, userRole)
            // }
  
          })
  
          return response
        }}>
          <Form.Item
            label="Rule Name"
            name="name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Criteria"
            name="condition_attribute"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select  onChange={toggleShowCount} filterOption={(inputValue, option:any) =>
    option?.children?.join('').toLowerCase().includes(inputValue.toLowerCase())
  }>
            {conditions.map((condition) => (
                <option selected={formProps?.initialValues?.condition_attribute===condition?.rule_id} key={condition.key} value={condition.rule_id}>
            
                        {condition.name}
                  
                </option>
            ))}
            </Select>
            
          {/* <Select onChange={toggleShowCount} options={[
        {
          value: 'creation_date',
          label: 'Question creation date',

        },
        {
          value: 'discrimantion_index',
          label: 'By discremination index',
        },
        {
          value: 'discrimantion_index_count',
        //   disabled: true,
          label: 'How many times the DI can be <=0 and <1',
        },
        {
          value: 'paper_count',
          label: 'How many times a question can be used in different papers',
        },
      ]}/> */}
        
        </Form.Item>
        <Form.Item
        hidden={!showdateRange}
            label="Date range"
            name="date_range_new"
            rules={[
              {
                required: false,
              },
            ]}
          >
    <RangePicker
    
    // onFocus={e => e.preventDefault()}
    // onBlur={e => e.preventDefault()}
       defaultValue={[moment(formProps?.initialValues?.date_range?.[0], dateFormat), moment(formProps?.initialValues?.date_range?.[1], dateFormat)]}
       onChange={onChange}
      // disabled={[false, true]}
    />
        </Form.Item>
        
        <Form.Item
        hidden={!showCount}
            label="Count"
            name="count"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Duration Range"
            name="duration_unit"
            rules={[
              {
                required: true,
              },
            ]}
          >
            
          <Select options={[
        {
          value: 'days',
          label: 'Days',
        },
        {
          value: 'months',
          label: 'Months',
        },
        {
          value: 'years',
        //   disabled: true,
          label: 'Years',
        },
        
      ]}/>
        
        </Form.Item>
        <Form.Item
            label="Duration"
            name="duration"
            rules={[
              {
                required: true,
              },
            ]}
          >
            
          <Select  tokenSeparators={[',']}
    options={options}/>
        
        </Form.Item>
        <Form.Item
            label="Status"
            name="active"
            rules={[
              {
                required: true,
              },
            ]}
          >
            
          <Select options={[
        {
          value: true,
          label: 'Activate',
        },
        {
          value: false,
          label: 'Deactivate',
        },
       
        
      ]}/>
        
        </Form.Item>
          <Form.Item name="updated_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
        </Form>
      </Modal>
    )
}